import GeoNavbar from './components/GeoNavbar';
import GeoHeroSection from './components/GeoHeroSection';
import WhatIsGeoSection from './components/WhatIsGeoSection';
import SeoVsGeoSection from './components/SeoVsGeoSection';
import LocalImpactSection from './components/LocalImpactSection';
import HowGeoWorksSection from './components/HowGeoWorksSection';
import WhatMakesAICiteSection from './components/WhatMakesAICiteSection';
import WhatIncludedSection from './components/WhatIncludedSection';
import GeoProcessSection from './components/GeoProcessSection';
import WhoItsForSection from './components/WhoItsForSection';
import GeoFaqSection from './components/GeoFaqSection';
import GeoPricingSection from './components/GeoPricingSection';
import Footer from '../../components/feature/Footer';
import GeoSchemaMarkup from './components/GeoSchemaMarkup';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://www.darksidedigital.com.au';

export default function GeoPage() {
  return (
    <div className="min-h-screen" style={{ background: '#0A0A0A' }}>
      {/* SEO metadata — React 19 hoists these to <head> automatically */}
      <title>GEO &amp; AEO Services | Get Found in ChatGPT &amp; AI Search | Darkside Digital</title>
      <meta
        name="description"
        content="Most businesses are invisible to ChatGPT, Gemini &amp; Perplexity. Darkside Digital&apos;s GEO &amp; AEO service gets your business cited by AI search engines — results in 6–10 weeks. Free AI audit included."
      />
      <meta
        name="keywords"
        content="GEO, AEO, generative engine optimisation, AI search visibility, ChatGPT SEO, answer engine optimisation"
      />
      <link rel="canonical" href={`${siteUrl}/geo-aeo`} />
      <meta name="last-modified" content="2026-03-22" />
      <meta property="og:type" content="website" />
      <meta property="og:title" content="GEO &amp; AEO Services | Get Found in ChatGPT &amp; AI Search | Darkside Digital" />
      <meta
        property="og:description"
        content="Most businesses are invisible to ChatGPT, Gemini &amp; Perplexity. Darkside Digital&apos;s GEO &amp; AEO service gets you cited by AI search — fast. Free audit included."
      />
      <meta
        property="og:image"
        content="https://static.readdy.ai/image/d975884ffe2514a0a224ba62f333db56/9ff49cf28e3f42c352e2fb623c0a4733.png"
      />
      <meta property="og:url" content={`${siteUrl}/geo-aeo`} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="GEO &amp; AEO | Get Your Business Cited by ChatGPT | Darkside Digital" />
      <meta
        name="twitter:description"
        content="47% of businesses have zero AI search strategy. Darkside Digital fixes that with GEO &amp; AEO — the next frontier beyond traditional SEO."
      />
      <meta
        name="twitter:image"
        content="https://static.readdy.ai/image/d975884ffe2514a0a224ba62f333db56/9ff49cf28e3f42c352e2fb623c0a4733.png"
      />
      <GeoSchemaMarkup />

      <GeoNavbar />
      <main>
        <GeoHeroSection />
        <WhatIsGeoSection />
        <SeoVsGeoSection />
        <LocalImpactSection />
        <HowGeoWorksSection />
        <WhatMakesAICiteSection />
        <WhatIncludedSection />
        <GeoProcessSection />
        <WhoItsForSection />
        <GeoFaqSection />
        <GeoPricingSection />
      </main>
      <Footer />
    </div>
  );
}
